
export const PRODUCE_RETAINER = 'produce_retainer'

export const PRODUCE_RETAINER_EXTERNAL = 'produce_retainer_external'

export const SHIP_RETAINER_EXTERNAL = 'ship_retainer_external'

export const SHIP_RETAINER = 'ship_retainer'

export const ORDER_RETAINER = 'order_retainer'



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/retainer/task-name.js